"use client";
export { Trans } from "react-i18next";
